<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import Mainbutton from "../components/Mainbutton.svelte";
  import Online from "../components/Online.svelte";
  import Form from "../components/Form.svelte";
  import { personHasFormData, send, sendform, getHost } from "../utils/sendwhatsapp_rewrite_chabi";
  import { getOrCreateVisitorId } from "../utils/localStorage";
  import Modal from "../components/Modal.svelte";
  import { tick } from "svelte";
  import Chat from "../components/Chat.svelte";
  import Payment from "../components/Payment.svelte";
  import Faqs from "../components/Faqs.svelte";
  import NewFaqs from "../components/NewFaqs.svelte";
  import FaqsChat from "../components/FaqsChat.svelte";
  import LeaveMessage from "../components/LeaveMessage.svelte";
  import Booking from "../components/booking/Booking.svelte";
  import { sendBooking } from "../utils/sendwhatsapp_rewrite_chabi";
  import WidgetHeader from "../components/WidgetHeader.svelte";
  import CountDown from "../components/CountDown.svelte";
  import FaqsChatAi from "../components/FaqsChatAi.svelte";

  export let person;
  export let data;
  export let dataHeader;

  $: hideAvatar = person?.hideAvatar;
  $: transparentBg = person?.transparentBg;

  let showfaqs = false;
  let showpayment = person.isExtraLink && person.type == "payment";
  let formitems = { items: [] };
  let visitorProfile = null;

  function prefillFormFromProfile(items) {
    if (!visitorProfile || !items) return items;
    return items.map((item) => {
      if (item.val) return item;
      if (item.type === "email" && visitorProfile.email) return { ...item, val: visitorProfile.email };
      if (item.type === "tel" && visitorProfile.phone) return { ...item, val: visitorProfile.phone };
      if ((item.type === "name" || (item.type === "text" && item.subtype === "firstname")) && visitorProfile.name) {
        return { ...item, val: visitorProfile.name };
      }
      return item;
    });
  }

  function applyVisitorProfile(form) {
    if (!form?.items) return form;
    return { ...form, items: prefillFormFromProfile(form.items) };
  }

  function handleVisitorProfile(event) {
    visitorProfile = event.detail.profile;
  }

  async function syncFormToVisitorProfile(formItems) {
    const visitorId = getOrCreateVisitorId(data.id);
    if (!visitorId || !person?.id) return;

    const name  = formItems.find((i) => i.subtype === "firstname" || i.subtype === "lastname" || i.type === "name")?.val || null;
    const email = formItems.find((i) => i.type === "email")?.val || null;
    const phone = formItems.find((i) => i.type === "tel")?.val || null;
    if (!name && !email && !phone) return;

    try {
      await fetch(`${getHost()}/ai/visitor/${person.id}/sync`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ visitorId, name, email, phone }),
      });
    } catch (_) {}
  }
  let isOpen = false;
  let isOpen2 = false;
  let threadId = null;
  let leadId = null;

  let noclose = true;

  let valueCopy = `<script defer data-widget-type="group" data-person="${person.id}"     src=\'/build/bundle.js?key=${data.id}\'><\/script><div id="whatapp-people-widget"><\/div>`;
  let areaDom;
  let faqlevel;

  let container;
  let wrapperDiv;
  let leaveamessage = false;
  let showbooking = false;
  let bookingConfig = {};
  let bookingEvent = null;
  $: showWideBooking =
    showbooking &&
    bookingConfig?.showCalendarAndHour === true;

  const isSimpleLink = person.isExtraLink && person.type != "payment";
  const linkHref = person.type == "link" ? person.url : (person.type == "email" ? "mailto:" : person.type + ":") + person.url;
  const linkTarget = person.type == "link" ? "_blank" : "_self";

  onMount(() => {
    if (isSimpleLink) {
      const child = document.createElement("a");
      child.target = person.type == "link" ? "_blank" : "_self";
      child.href = (person.type == "link" ? "" : (person.type == "email" ? "mailto" : person.type) + ":") + person.url;
      child.style["text-decoration"] = "none";
      child.append(wrapperDiv);
      container?.append(child);
    }
    if (person?.bookingConfigs?.length > 0) {
      bookingConfig = person?.bookingConfigs[0];
      showbooking = true;
    }
  });

  if (person?.faqGrps?.length > 0 && !person.formBeforeFaqs) {
    data.activeFaqs = person.faqGrps[0];
    showfaqs = true;
    faqlevel = "whatsapp";
  } else if (data.faqGrps?.length > 0 && !person.formBeforeFaqs) {
    data.activeFaqs = data.faqGrps[0];
    showfaqs = true;
    faqlevel = "business";
  } else {
    showfaqs = false;
  }

  async function copy() {
    await tick();
    areaDom.focus();
    areaDom.select();
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        alert("Text copied to clipboard");
      }
    } catch (err) {
      //console.log("could not copy to clipbloard");
    }
  }

  if (person.form) {
    formitems = applyVisitorProfile(person.form);
  }

  function close() {
    showform = false;
  }

  async function sf(event) {
    const formDataSnapshot = (event.detail?.data ?? []).map(i => ({ ...i }));
    const snapshotEvent = { ...event, detail: { ...event.detail, data: formDataSnapshot } };
    syncFormToVisitorProfile(formDataSnapshot); // fire and forget — no await to preserve user gesture for window.open

    if (person.formBeforeFaqs) {
      showfaqs = true;
    }

    const lead = await sendform(person, snapshotEvent, data.redirectUrl, data.sellLeads, data.id, threadId);
    if (lead) leadId = lead;
  }

  function handleClick(event) {
    //if there is no form and not online - nothing
    leaveamessage = false;
    if (!person.form && ((person.online === false && data.offlineLeads === true) || (data.desktopLeads === true && window.innerWidth > 1000))) {
      leaveamessage = true;
      return;
    }
    if (person.form) {
      showform = true;
    } else {
      if (isSimpleLink) {
        return;
      }
      if (data.redirectUrl) {
        window.location.href = data.redirectUrl;
        return;
      }
      send(person, data.redirectUrl, event);
    }
  }

  function handleThread(event) {
    threadId = event.detail.threadId;
  }

  function problemSolved() {}

  function problemNotSolved() {
    const hasForm = personHasFormData(person);
    if (hasForm === false && person.online === false) {
      return;
    }
    //send the whatsapp
    else if (hasForm === false || person.formBeforeFaqs) {
      if (data.redirectUrl) {
        window.open(data.redirectUrl);
        return;
      }
      if (!person.formBeforeFaqs) {
        send(person, data.redirectUrl, {});
      }
    } else {
      showfaqs = false;
    }
  }

  function openLeadForm() {
    if (!personHasFormData(person)) return;

    leaveamessage = false;
    showfaqs = false;
    showbooking = false;
    formitems = applyVisitorProfile(person.form);
  }

  const handleBooking = (event) => {
    if (person?.onboardPaymentLinks?.length > 0) {
      person.onboardPaymentLinks.forEach((value) => {
        if (value.showOnWidget && value.useStripe) {
          person = {
            name: value.name,
            iconUrl: value.image,
            online: true,
            isExtraLink: true,
            type: "payment",
            id: value.link,
            bookingConfigs: person?.bookingConfigs,
          };
          if (!data.onboardPaymentLinks) {
            data.onboardPaymentLinks = [];
          }
          data.onboardPaymentLinks.push(value);
          showpayment = true;
          bookingEvent = event;
        } else {
          sendBooking(person, event);
        }
      });
    } else {
      sendBooking(person, event);
    }
  };

  const handleSimpleLinkClick = (event) => {
    window.open(linkHref, linkTarget);
  };
</script>

<div id={"chatwith-big-agent-" + (person.id || Math.random().toString(36).slice(2))} class="chatwith-big-person" class:hideAvatar class:isSimpleLink class:transparentBg class:wideBooking={showWideBooking} class:chatwith-landing-ai={data.landingDefault === true && person.aiChatFaq === true}>
  <div
    class="singleperson {person?.bookingConfigs?.length > 0 ? '' : person.online === true ? 'active' : 'inactive'}"
    style="padding: {dataHeader ? 0 : '1.25em 1.25em 20px'}"
    on:click={(e) => {
      if (isSimpleLink) handleSimpleLinkClick(e);
    }}
  >
    {#if dataHeader}
      <WidgetHeader hideClose={true} {data} {dataHeader} />
    {/if}
    <CountDown {data} hasBanner={true} />
    {#if !person.hideCompleteBlock}
      <div class="person-header-row">
        <div class="avatar">
          <div class="image-wrapper">
            <img class="avatar-pic" alt="" src={person.iconUrl} />
          </div>
          {#if person?.bookingConfigs?.length === 0}
            <Online {person} hideOnlineLabel={data.hideOnlineLabel} />
          {/if}
        </div>

        <div class="chatwith-big-person-persondata">
        {#if !dataHeader && data.whatsapps.length == 1}
          <div class="chatwith-big-person-message">{data.widgetMessage}</div>
        {/if}

        {#if person.post && person.post != "null" && person.post != null}
          <div class="chatwith-big-person-post">{person.post}&nbsp;</div>
        {/if}
        <div class="chatwith-big-person-name"><strong>{person.name}</strong></div>
        {#if person.chatform && person?.bookingConfigs?.length === 0}
          <div class="chatwith-chatform-progress">
            <div class="chatwith-chatform-progress-bar" id="chatwith-chatform-progress-bar" />
          </div>
        {/if}
        <Modal {isOpen}>
          <div style="font-size: 14px;margin: 10px;font-weight: bold">Copy and paste this code into your website</div>
          <textarea on:click={copy} bind:this={areaDom} style="font-size: 14px;color: #999" rows="7">
            {valueCopy}
          </textarea>
        </Modal>

        <Modal isOpen={isOpen2}>
          <div style="font-weight: bold;font-size: 14px; padding-bottom:10px">
            {data.translateOnlineFrom ?? "I'm online from"}:
          </div>
          <table style="font-size: 14px">
            {#each person.optimes as i}
              <tr>
                <td style="padding: 2px;text-align: left">{i.day}</td>
                <td style="padding: 2px;text-align: left">{i.availableFrom.slice(0, -3)}</td>
                <td style="padding: 2px;text-align: left"> {i.availableUntil.slice(0, -3)}</td>
                <td style="color:#999;padding: 2px;text-align: left">
                  {#if i.timezone}{i.timezone}{/if}
                </td>
              </tr>
            {/each}
          </table>
        </Modal>
        </div>
      </div>
    {/if}
    {#if showpayment}
      <Payment {data} {bookingEvent} {person} {noclose} />
    {:else if formitems.items.length == 0 && !showfaqs && !isSimpleLink}
      <div class="widget-button-wrapper" bind:this={container}>
        <div bind:this={wrapperDiv}>
          <Mainbutton on:close={handleClick} {data} widgetType="BigPerson" />
        </div>
      </div>
    {/if}
    <div class="copy-widget-wrapper">
      <span on:click={() => (isOpen = Math.random())}>
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="far"
          data-icon="copy"
          class="svg-inline--fa fa-copy fa-w-14"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          ><path
            fill="currentColor"
            d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
          /></svg
        >
        Copy widget
      </span>
    </div>
    {#if person.optimes && person.optimes.length > 0}
      <div class="timetable">
        <span on:click={() => (isOpen2 = Math.random())}>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="user-clock"
            class="svg-inline--fa fa-user-clock fa-w-20"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
            ><path
              fill="currentColor"
              d="M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
            /></svg
          >
          {data.translateShowTimetable ?? "Show timetable"}
        </span>
      </div>
    {/if}
    {#if !showpayment}
      {#if leaveamessage === true}
        <div style="padding:10px">
          <LeaveMessage {data} {person} />
        </div>
      {:else if showfaqs}
        <div class="chat-container" in:fade>
          {#if person.aiChatFaq === true}
            <FaqsChatAi
              on:problem-solved={problemSolved}
              on:problem-not-solved={problemNotSolved}
              on:open-lead-form={openLeadForm}
              on:thread-id={handleThread}
              on:visitor-profile={handleVisitorProfile}
              activePerson={person}
              {data}
              {leadId}
            />
          {:else if data.aiChatFaq === true}
            <FaqsChat on:problem-solved={problemSolved} on:problem-not-solved={problemNotSolved} activePerson={person} {faqlevel} {data} />
          {:else if data.faqDisplay === true}
            <NewFaqs on:problem-solved={problemSolved} on:problem-not-solved={problemNotSolved} faqs={data.activeFaqs} activePerson={person} {data} />
          {:else}
            <Faqs on:problem-solved={problemSolved} on:problem-not-solved={problemNotSolved} faqs={data.activeFaqs} activePerson={person} {data} />
          {/if}
        </div>
      {:else if formitems.items.length > 0}
        {#if person.chatform && person?.bookingConfigs?.length === 0}
          <div class="chat-container">
            <div class="chat-container-box">
              <Chat {data} activePerson={person} formOverride={formitems} on:callmex={sf} isBigperson={true} />
            </div>
          </div>
        {:else if showbooking}
          <Booking on:close={() => (showbooking = false)} on:submit={handleBooking} {person} {bookingConfig} noclose={true} {data} />
        {:else}
          <Form on:callmex={sf} on:close={close} on:booking={() => (showbooking = true)} {data} {person} {formitems} {noclose} isBigperson={true} />
        {/if}
      {/if}
    {/if}
  </div>
</div>
